import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";

//limitless imports
import { propsRewardsImage1, propsRewardsImage2, propsRewardsImage3 } from "@limitless/images";
import SectionHeader from "../section-header/SectionHeader";
const useStyles = makeStyles(theme => ({
  container: {
    paddingLeft: 0
  },
  contentContainer: {
    marginTop: "2%"
  },
  imageContent: {
    maxHeight: 125,
    paddingLeft: 10
  },
  textContainer: {
    minHeight: 125,
    paddingLeft: "2%",
    textAlign: "left",
    marginTop: 16,
    wordWrap: "break-word",
    overflow: "hidden"
  },
  [theme.breakpoints.up("sm")]: {
    textContainer: {
      textAlign: "center",
      marginTop: 0
    }
  },
  [theme.breakpoints.up("xs")]: {
    textContainer: {
      textAlign: "center",
      marginTop: 0
    }
  },
  [theme.breakpoints.up("lg")]: {
    textContainer: {
      textAlign: "center",
      marginTop: 0
    },
    container: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }
}));
const propsAndRewardsImages = [propsRewardsImage1, propsRewardsImage2, propsRewardsImage3];
const PropAndRewards = ({
  content,
  leftSpaceContainer,
  useAltDesign,
  extraHeaderStyle = ""
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    className: leftSpaceContainer
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    header: content.header,
    extraHeaderStyle: extraHeaderStyle
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    className: useAltDesign ? classes.container : leftSpaceContainer
  }, content === null || content === void 0 ? void 0 : content.propositions.map((value, index) => /*#__PURE__*/React.createElement(Grid, {
    key: index,
    item: true,
    container: true,
    xs: 12,
    sm: 4,
    className: classes.contentContainer,
    justifyContent: "center",
    alignItems: "center",
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    component: "img",
    src: propsAndRewardsImages[index],
    alt: "props-rewards",
    className: classes.imageContent
  }), /*#__PURE__*/React.createElement(Grid, {
    xs: 12,
    sm: 12,
    lg: 12,
    md: 12,
    item: true,
    className: classes.textContainer,
    style: !useAltDesign ? {
      textAlign: "center",
      marginTop: 0
    } : {}
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textPrimary",
    style: {
      marginBottom: 12,
      marginTop: 8
    }
  }, value.header), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary",
    style: {
      marginLeft: 7,
      marginRight: 7
    }
  }, value.text))))));
};
PropAndRewards.propTypes = {
  content: PropTypes.object.isRequired,
  leftSpaceContainer: PropTypes.string,
  extraHeaderStyle: PropTypes.string,
  useAltDesign: PropTypes.bool
};
export default PropAndRewards;